module.exports = __webpack_public_path__ + "img/get-item-task.54800b42.svg";